import { useUser } from '@micro-frontend-react/employee-experience/lib/useUser';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IContentManagementAppState } from '../../../App.types';
import { ApplicationsReducerName, requestApplications } from '../Applications';
import { requestViews } from './Views.actions';
import { ViewsReducerName } from './Views.types';

export function useViews(applicationId: string, viewId: string = null) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestApplications());
    dispatch(requestViews(applicationId));
  }, []);

  const state = useSelector((appState: IContentManagementAppState) => appState[ViewsReducerName]);
  const { applications } = useSelector((appState: IContentManagementAppState) => appState[ApplicationsReducerName]);
  const application = applications?.find((a) => a.id === applicationId);
  const user = useUser();

  return {
    applicationName: application?.name || 'Loading...',
    isApplicationOwner: !!application?.owners.find((p) => p === user?.id) ?? false,
    selectedView: viewId === null ? null : state.views?.find((p) => p.id === viewId),
    ...state,
  };
}
